<script setup lang="ts">
import { useProjectsStore } from '@/modules/projects/stores/useProjectsStore'
import { useRouter } from 'vue-router'

const emit = defineEmits<{ close: [] }>()

const projectsStore = useProjectsStore()
const router = useRouter()

function selectProject(project: { id: string; name: string; isActive: boolean }) {
  const full = projectsStore.items.find(p => p.id === project.id)
  if (full) {
    projectsStore.setCurrentProject(full)
    router.push('/')
  }
  emit('close')
}
</script>

<template>
  <!-- Backdrop -->
  <div class="fixed inset-0 z-[59]" @click="emit('close')"></div>

  <!-- Panel -->
  <div
    class="absolute z-[60] bg-base-100 border border-white/10 rounded-lg shadow-xl py-2 min-w-[200px] max-h-[300px] overflow-y-auto"
    style="left: calc(100% + 12px); top: 0;"
  >
    <div class="px-3 py-1.5 text-2xs font-semibold uppercase tracking-widest text-gray-500">
      Projekt
    </div>

    <button
      v-for="pw in projectsStore.projectsWithPermissions"
      :key="pw.project.id"
      class="w-full flex items-center gap-2.5 px-3 py-2 text-sm cursor-pointer transition-colors duration-100"
      :class="projectsStore.currentProject?.id === pw.project.id
        ? 'bg-amber-400/10 text-amber-400'
        : 'text-gray-400 hover:bg-base-200 hover:text-gray-200'"
      @click="selectProject(pw.project)"
    >
      <span
        class="w-2 h-2 rounded-full flex-shrink-0"
        :class="pw.project.isActive ? 'bg-amber-400' : 'bg-red-500'"
      ></span>
      <span class="truncate">{{ pw.project.name }}</span>
    </button>

    <div
      v-if="projectsStore.projectsWithPermissions.length === 0"
      class="px-3 py-2 text-sm text-gray-500"
    >
      Žádné projekty
    </div>
  </div>
</template>
